module.exports = __webpack_public_path__ + "img/instagram-icon.afcbc845.svg";